import React, {useEffect} from "react";
import styled from "styled-components";
import { Col, Form, Image, Input, Row } from "antd";
import { useStore } from "../../store";
import { BaseImageUrl } from "../../http/http";

const defaultIcon = require("../../image/default-pic.png")

const PictureDetail:React.FC = () => {

    const [form] = Form.useForm();
    const { PictureStore } = useStore();
    useEffect(() => {
        const { showBaseLibraryDetail } = PictureStore;
        const detail = JSON.parse(JSON.stringify(showBaseLibraryDetail));
        form.setFieldsValue(detail);
    }, []);
    const pictureForm = () => {
        return <Form preserve={false} title={"原植物图库信息"}  disabled={true} form={form} layout={"vertical"} size={"middle"} >
            <Row gutter={24}>
            <Col span={8}>
                    <Form.Item label={"中文名:"} name={"cnName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"拉丁文:"} name={"ldName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"属中文名:"} name={"genCnName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"属拉丁文:"} name={"genLdName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"科中文名:"} name={"specCnName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"科拉丁名:"} name={"specLdName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"图片地址:"} name={"imgUrl"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"图片:"} required={true}>
                        {PictureStore.showBaseLibraryDetail?.imgUrl && <Image preview={false} src={BaseImageUrl+PictureStore.showBaseLibraryDetail?.imgUrl} fallback={defaultIcon}/>}
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    }

    return(<Wrapper>
        { pictureForm() }
    </Wrapper>);
}

export default PictureDetail;


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 30px;
  max-height: 500px;
  overflow: auto;
  .ant-picker{
    width: 100%;
  }
`;
const secondTitle = styled.div`
  & {
    font-size: 17px;
    line-height: 17px;
    margin: 10px 0;
  }
`;